// @flow

import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {noTranslateMessages} from 'docs/intl/noTranslate';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';
import {InlineCode} from '../../core/InlineCode/InlineCode';

type SupportedTaxIdTableEntryType = {|
  countryName: string,
  externalType: string,
  description: string,
  placeholder: string,
|};

type SupportedTaxIdTableProps = {|
  entries: Array<SupportedTaxIdTableEntryType>,
  children?: React.Node,
|};

export const SupportedTaxIdTable = ({entries}: SupportedTaxIdTableProps) => {
  if (!entries) {
    return null;
  }

  return (
    <Table type="striped">
      <thead>
        <tr>
          <TableHeaderCell>
            <FormattedMessage
              id="docsApp.components.taxCodeDetails.column.country"
              description="column header for the tax id country"
              defaultMessage="Country"
            />
          </TableHeaderCell>
          <TableHeaderCell>
            <FormattedMessage
              id="docsApp.components.taxCodeDetails.column.enum"
              description="column header for the tax id code"
              defaultMessage="Enum"
            />
          </TableHeaderCell>
          <TableHeaderCell>
            <FormattedMessage
              id="docsApp.components.taxCodeDetails.column.description"
              description="column header for the tax id description"
              defaultMessage="Description"
            />
          </TableHeaderCell>
          <TableHeaderCell>
            <FormattedMessage
              id="docsApp.components.taxCodeDetails.column.example"
              description="column header for the tax id example"
              defaultMessage="Example"
            />
          </TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {entries.map((entry, i) => {
          const messages = noTranslateMessages({
            description: {
              id: `docsApp.tax_id_types.${entry.externalType}.description`,
              defaultMessage: entry.description,
            },
          });

          return (
            <tr key={i}>
              <TableCell>{entry.countryName}</TableCell>
              <TableCell>
                <InlineCode>{entry.externalType}</InlineCode>
              </TableCell>
              <TableCell>
                <FormattedMessage {...messages.description} />
              </TableCell>
              <TableCell>
                <em>{entry.placeholder}</em>
              </TableCell>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
